document.addEventListener('turbolinks:load', () => {
    if (!$('body.available_times').length) return;

    $('table.time-table input[type="checkbox"]').change(function() {
        const $this = $(this);
        if ($this.prop('checked')) $this.parent().addClass('checked');
        else $this.parent().removeClass('checked');
    });

});